import * as React from "react";
import { Stack, StackProps, Typography, styled } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import { useTranslation } from "react-i18next";
interface ConfigPackageBundleMetadataProps extends StackProps {
  title: string;
  status: "complete" | "missing";
  onClick: () => void;
}

const ConfigPackageBundleMetadata: React.FC<ConfigPackageBundleMetadataProps> = (props) => {
  const { t } = useTranslation();
  const { title, status, onClick, ...otherProps } = props;
  return (
    <Card
      onClick={onClick}
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      spacing={2}
      role="button"
      {...otherProps}
    >
      <Typography color="text.primary" fontWeight={500}>
        {title}
      </Typography>
      <Stack direction="row" alignItems="center" spacing={0.5}>
        {status === "complete" && (
          <>
            <Typography color="success.main" variant="body2" fontWeight={500}>
              {t("common:complete")}
            </Typography>
            <CheckIcon fontSize="small" color="success" />
          </>
        )}
        {status === "missing" && (
          <Typography color="warning.main" variant="body2" fontWeight={500}>
            {t("component:body.informationMissing")}
          </Typography>
        )}
      </Stack>
    </Card>
  );
};

export default ConfigPackageBundleMetadata;

const Card = styled(Stack)(({ theme }) => ({
  borderRadius: 8,
  padding: `${theme.spacing(1.5)} ${theme.spacing(2)}`,
  border: `1px solid ${theme.palette.backgroundAlpha.border}`,
  cursor: "pointer",
}));
